var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{},[_c('b-jumbotron',{attrs:{"header":"ASM80 Tools Suite","lead":"Useful tools for HEX, BIN, ASM processing"}},[_c('p',[_vm._v("Select desired tool from the menu above")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }